import React from 'react'

export interface ButtonLikeLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ButtonLikeLink = (props: ButtonLikeLinkProps) => {
  const { children, ...rest } = props
  const baseClassName = `flex items-center
    text-brand-primary 
    [&>svg>path]:fill-brand-primary main-transition-colors [&>svg>path]:main-transition-colors`

  return (
    <button
      {...rest}
      className={`
        ${baseClassName}
        ${
          rest.disabled
            ? 'text-text-secondary [&>svg>path]:fill-text-secondary'
            : '[&:hover]:text-text-secondary [&:hover>svg>path]:fill-text-secondary'
        }
        ${props.className || ''} 
      `}
    >
      {children}
    </button>
  )
}

export default ButtonLikeLink
